// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles-module__dialog___IcBtv","list":"styles-module__list___xdVbK","cat":"styles-module__cat___Ub8zp"};